import React from 'react'
import { render } from 'react-dom'
import App from './components/App'

render(
  <App />,
  document.getElementById('root')
)



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/